const volcanes = {
  inputCustomerName: 'Full Name',
};

module.exports = volcanes;
